import type { CommandData } from '@festina/legalentity-general-types/legalentity'
import type { ExcludeString } from '@festina-life/core'

import type { CommandDataRecord } from '../types'
import { annotationCommands } from './annotationCommands'
import { companyCommands } from './companyCommands'
import { personCommands } from './personCommands'

export const legalentityCommands: CommandDataRecord<
  ExcludeString<CommandData['_type']>
> = {
  ...annotationCommands,
  ...companyCommands,
  ...personCommands,
} as const
